module.exports = __webpack_public_path__ + "media/images/iconTrendDown__accent-ee387ffff6e189b9748b8025c76fe90a.png";